function HeaderController() {
  $(document).on("keyup", "#search-lists", function (event) {
    if (event.keyCode == 13) {
      window.location = "/lists?query=" + $("#search-lists").val();
    }
  });
}

module.exports = HeaderController;
